export default function ViewerLoading({ label, subtle = false }) {
  return (
    <div
      className={`sv-loading-overlay${subtle ? " sv-loading-overlay-subtle" : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="sv-loading-spinner" aria-hidden="true" />
      {label && <span className="sv-loading-label">{label}</span>}
    </div>
  );
}
